import React, { Component } from "react";
import "./MAMCASurveySetting.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Popconfirm, Table, Empty, Spin, Switch,
    Modal, Button, Form, Input, Tabs, Result,
    Select, Icon, Checkbox, Row, Col, Tag, Alert

} from 'antd';
import { Link } from "react-router-dom";
var QRCode = require('qrcode.react');
const TabPane = Tabs.TabPane;

//create crteria modal
const CreateForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const Option = Select.Option;
            const {
                visible, onCancel, onCreate, form, criteriaGroup
            } = this.props; //read all the property send from criteria


            //print all the criteria group of this MCA
            const children = [];
            for (let i in criteriaGroup) {
                children.push(<Option key={criteriaGroup[i]}>{criteriaGroup[i]}</Option>);
            }

            const { getFieldDecorator } = form; //can get the input value
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Create a new question"
                    okText="Create"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Form layout="vertical">
                        <Form.Item label="Question">
                            {getFieldDecorator('question', {
                                rules: [
                                    { required: true, message: 'Please input the question!' }
                                ], //set the rule
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Question options">
                            {getFieldDecorator('questionOptions', {
                                rules: [
                                    { type: 'array' }, //set the transfered data type
                                ],
                            })(
                                <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    placeholder="Please enter your question options">
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="Create an open option to let interviewees to enter their own answer">
                            {getFieldDecorator('questionOpen', { valuePropName: 'checked' })(
                                <Switch />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);


//edit criteria modal
let EditForm = Form.create({ name: 'edit_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                visible, onCancel, onCreate, form, eQuestion//get all the props from criteria
            } = this.props;

            const { getFieldDecorator } = form;
            return (
                <Modal
                    visible={visible}
                    title={"Edit Question " + eQuestion.question} //the name is different per modal
                    okText="Edit"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Form layout="vertical">
                        <Form.Item label="Question">
                            {getFieldDecorator('question', {
                                rules: [{ required: true, message: 'Please enter the question!' }],
                                initialValue: eQuestion.question //get the oringinal criterion name
                            })(
                                <Input />
                            )}
                        </Form.Item>
                        <Form.Item label="Question options">
                            {getFieldDecorator('questionOptions', {
                                rules: [
                                    { type: 'array' }, //set the transfered data type
                                ],
                                initialValue: eQuestion.questionOptions
                            })(
                                <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    placeholder="Please enter your question options">
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="Create an open option to let interviewees to enter their own answer">
                            {getFieldDecorator('questionOpen', {
                                // rules: [{ required: true, message: 'Please input the indicator!' }],
                                valuePropName: 'checked',
                                initialValue: eQuestion.questionOpen,
                            })(
                                <Switch />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    }
);

//create publish modal
const PublishForm = Form.create({ name: 'publish_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                visible, onCancel, onCreate, form, actorEvaluatable, surveyLink
            } = this.props; //read all the property send from criteria
            const { getFieldDecorator } = form; //can get the input value
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Publish page"
                    okText="Publish"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Form layout="vertical">
                        <Form.Item>
                            {getFieldDecorator('actorWeightable', {
                                // rules: [{ required: true, message: 'Please input the indicator!' }],
                                valuePropName: 'checked',
                                initialValue: true,
                                // initialValue: actorWeightable,
                            })(
                                <Checkbox disabled
                                >
                                    Allow interviewees to weigh the criteria
                            </Checkbox>
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('actorEvaluatable', {
                                // rules: [{ required: true, message: 'Please input the indicator!' }],
                                valuePropName: 'checked',
                                initialValue: actorEvaluatable,
                            })(
                                <Checkbox
                                >
                                    Allow interviewees to evaluate the alternatives
                            </Checkbox>
                            )}
                        </Form.Item>
                        <Alert message="Please make sure you already finish the project basic setting (creating alternatives, actor groups, criteria)!" type="warning" />
                        {/* {form.getFieldValue("actorWeightable") && form.getFieldValue("actorEvaluatable") ? <span /> :
                            <Alert message="Please make sure you already evalauted as a project manager before publishing the survey!" type="warning" />
                        } */}
                    </Form>
                    {surveyLink === "" ? <span></span> :
                        <Result
                            status="success"
                            title="Survey link generated successfully!"
                            subTitle={`Here is the survey link: ${surveyLink}`}
                            extra={[
                                <h4 key = "QR">QR code</h4>,
                                <QRCode key = "QRCode" value={surveyLink} />,
                            ]}
                        />
                    }
                </Modal>
            );
        }
    }
);

export default class MAMCASurveySetting extends Component {
    constructor(props) {
        super(props);
        const panes = [
            { title: 'Tab 1', key: '1' },
        ];
        this.state = {
            activeKey: Cookie.get('activeKey'),
            email: Cookie.get("email"),
            MCAQuestions: [],
            MCACriteriaGroup: [],
            MCAid: "",
            createVisible: false, //for create modal
            editVisible: false, //for edit modal,
            publishVisible: false, //for publish modal,
            loading: true, //the loading status default true
            eQuestion: {}, //for edited criterion
            activeKey: '1',
            panes,
            projectActors: [],
            actorWeightable: true,
            actorEvaluatable: true,
            surveyLink: ""
        };
    }


    onChange = (activeKey) => {
        Cookie.set('activeKey', activeKey);
        this.formRef.props.form.resetFields(); //reset the form
        this.EformRef.props.form.resetFields(); //reset the form
        this.PformRef.props.form.resetFields(); //reset the form
        let MCAQuestions = []
        if (this.state.projectActors[activeKey - 1].actorSurveySettings) {
            if (this.state.projectActors[activeKey - 1].actorSurveySettings.actorQuestions) {
                MCAQuestions = this.state.projectActors[activeKey - 1].actorSurveySettings.actorQuestions
            }
        }
        this.setState({
            activeKey,
            MCAid: this.state.projectActors[activeKey - 1]._id,
            MCAQuestions: MCAQuestions,
            actorWeightable: this.state.projectActors[activeKey - 1].actorSurveySettings.actorWeightable,
            actorEvaluatable: this.state.projectActors[activeKey - 1].actorSurveySettings.actorEvaluatable,
            surveyLink: ""
        });
    }

    weightOnChange = e => {
        this.setState({
            actorWeightable: e.target.checked,
        });
    }

    evaluateOnChange = e => {
        this.setState({
            actorEvaluatable: e.target.checked,
        });
    }

    //show or cancel create modal
    showCreateModal = () => {
        this.setState({ createVisible: true });
    }

    handleCreateCancel = () => {
        this.setState({ createVisible: false });
    }

    //show or cancel edit modal
    showEditModal = () => {
        this.setState({ editVisible: true });
    }

    handleEditCancel = () => {
        this.setState({ editVisible: false });
    }

    //show or cancel publish modal
    showPublishModal = () => {
        this.setState({ publishVisible: true });
    }

    handlePublishCancel = () => {
        this.setState({ publishVisible: false });
    }

    //create alternative
    handleCreate = () => {
        const form = this.formRef.props.form; //get all the data from modal

        form.validateFields((err, values) => { //can get values based on name 
            let duplicate = false
            this.state.MCAQuestions.forEach(obj => {
                if (obj.question === values.question) {
                    duplicate = true
                }
            })
            if (err || values.question.trim().length === 0) { //trim the project name to check the length
                return;
            }
            else if (duplicate) {
                this.setState({ createVisible: false }); //make modal invisible
                message.error("Same question already exists")
            }
            else {
                fetch('/project/createSurveyQuestion', { //REST create alternative
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        actid: this.state.MCAid, //get the id of alternative
                        question: values.question.trim(),
                        questionOptions: values.questionOptions,
                        questionOpen: values.questionOpen,
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getProjectActors();
                            message.success(json.message); //create successfully, show message
                            this.setState({ createVisible: false }); //make modal invisible
                            form.resetFields(); //reset the form
                        }
                        else {
                            message.error(json.message); //create unsuccessful, show alert
                        }
                    });

            }
        });
    }

    //edit alterntive
    handleEdit = () => {
        const form = this.EformRef.props.form; //get data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err || values.question.trim().length === 0) { //trim the project name to check the length
                return;
            }
            else {
                if (values.question.trim() === this.EformRef.props.eQuestion.question && values.questionOptions === this.EformRef.props.eQuestion.questionOptions && this.EformRef.props.eQuestion.questionOpen === values.questionOpen) { //no change
                    this.setState({ editVisible: false }); //make modal invisible
                    form.resetFields(); //reset the form
                }
                else {
                    let nameNotChanged = false
                    let duplicate = false
                    if (values.question.trim() === this.EformRef.props.eQuestion.question && values.questionOptions !== this.EformRef.props.eQuestion.questionOptions && this.EformRef.props.eQuestion.questionOpen === values.questionOpen) {
                        nameNotChanged = true
                    }
                    if (values.question.trim() === this.EformRef.props.eQuestion.question && values.questionOptions === this.EformRef.props.eQuestion.questionOptions && this.EformRef.props.eQuestion.questionOpen !== values.questionOpen) {
                        nameNotChanged = true
                    }
                    if (values.question.trim() === this.EformRef.props.eQuestion.question && values.questionOptions !== this.EformRef.props.eQuestion.questionOptions && this.EformRef.props.eQuestion.questionOpen !== values.questionOpen) {
                        nameNotChanged = true
                    }
                    this.state.MCAQuestions.forEach(obj => {
                        if (obj.question === values.question.trim() && nameNotChanged === false) { //name changed but find same question
                            duplicate = true
                        }
                    })
                    if (duplicate) {
                        this.setState({ createVisible: false }); //make modal invisible
                        form.resetFields(); //reset the form
                        message.error("Same question already exists")
                    }
                    else {
                        fetch('/project/editSurveyQuestion', { //REST edit project
                            method: 'post',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                uid: this.props.match.params.projectid,
                                actid: this.state.MCAid, //get the id of alternative
                                sid: this.EformRef.props.eQuestion._id,
                                question: values.question.trim(),
                                questionOptions: values.questionOptions,
                                questionOpen: values.questionOpen,
                                nameNotChanged: nameNotChanged,
                            }),
                        }).then(res => res.json())
                            .then(json => {
                                if (json.success) {
                                    this.getProjectActors();
                                    message.success(json.message); //create successfully, show message
                                    this.setState({ editVisible: false }); //make modal invisible
                                    form.resetFields(); //reset the form
                                }
                                else {
                                    message.error(json.message); //create unsuccessful, show alert
                                }
                            });
                    }
                }
            }
        });
    }

    deleteMCACriteria(record) { //delete alternative
        fetch('/project/deleteSurveyQuestion', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                actid: this.state.MCAid, //get the id of alternative
                sid: record._id
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProjectActors(); //if success, refresh the criteria list
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });
    }


    handlePublish = () => {
        const form = this.PformRef.props.form; //get data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (err) {
                return;
            }
            if(values.actorWeightable===undefined){
                values.actorWeightable=false
            }
            if(values.actorEvaluatable===undefined){
                values.actorEvaluatable=false
            }
            if (values.actorWeightable === this.PformRef.props.actorWeightable && values.actorEvaluatable === this.PformRef.props.actorEvaluatable) { //no change
                this.setState({
                    surveyLink: `https://mamca.vub.be/mamcasurvey/${this.props.match.params.projectid}/${this.state.MCAid}`
                }) //http://localhost:3001/ https://mamca.vub.be/
            }
            else {
                fetch('/project/savePermissions', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        actid: this.state.MCAid, //get the id of alternative
                        actorWeightable: values.actorWeightable,
                        actorEvaluatable: values.actorEvaluatable
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getProjectActors(); //if success, refresh the criteria list
                            this.setState({
                                surveyLink: `https://mamca.vub.be/mamcasurvey/${this.props.match.params.projectid}/${this.state.MCAid}`
                            })
                            // message.success(json.message); //delete successful, show message
                            // this.setState({ publishVisible: false }); //make modal invisible
                            // form.resetFields(); //reset the form
                        }
                        else {
                            message.error(json.message)
                        }
                    });
            }

        })
    }

    //get the actors and criteria
    getProjectActors = () => {
        fetch(`/project/getMAMCASurvey/${this.props.match.params.projectid}`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) { //set tabs
                    let panes = []
                    let index = 1
                    json.MAMCAActorGroups.forEach(obj => {
                        panes.push({ title: obj.actorGroupName, key: index, id: obj._id })
                        index++
                    })
                    // const result = [{ criteriaGroup: [...new Set([].concat(...json.MAMCAActorGroups[this.state.activeKey - 1].actorCriteria.map(o => o.criteriaName)))] }]; //magic function for save unique criteria group in one list                   
                    let MCAQuestions = []
                    if(json.MAMCAActorGroups && json.MAMCAActorGroups.length !== 0){
                        if (json.MAMCAActorGroups[this.state.activeKey - 1].actorSurveySettings) {
                            if (json.MAMCAActorGroups[this.state.activeKey - 1].actorSurveySettings.actorQuestions) {
                                MCAQuestions = json.MAMCAActorGroups[this.state.activeKey - 1].actorSurveySettings.actorQuestions
                            }
                        }
                    
                   
                    this.setState({
                        projectName: json.projectName,
                        projectActors: json.MAMCAActorGroups,
                        MCAQuestions: MCAQuestions,
                        actorWeightable: json.MAMCAActorGroups[this.state.activeKey - 1].actorSurveySettings.actorWeightable,
                        actorEvaluatable: json.MAMCAActorGroups[this.state.activeKey - 1].actorSurveySettings.actorEvaluatable,
                        panes: panes,
                        MCAid: json.MAMCAActorGroups[this.state.activeKey - 1]._id,
                        loading: false
                    }) //save project data
                }
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }


    //save all the form data of create
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }

    //save all the form data of edit
    saveEFormRef = (formRef) => {
        this.EformRef = formRef;
    }

    //save all the form data of publish
    savePFormRef = (formRef) => {
        this.PformRef = formRef;
    }

    checkDisable() {
        let disable = false
        this.state.projectActors.forEach(obj => {
            if (obj.actorCriteria.length < 1) {
                disable = true
            }
        })
        return disable
    }

    componentDidMount() {
        try {
            this.getProjectActors() //get actor group first
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const columns = [{ //the column title of the table
            title: 'Survey question', //the title of column
            dataIndex: 'question', //the data index can be used for searching, filtering
            key: 'profileName',
            width: '35%',
        },
        { //the column title of the table
            title: 'Question options', //the title of column
            dataIndex: 'questionOptions', //the data index can be used for searching, filtering
            key: 'options',
            width: '35%',
            render: tags => ( //print all the tag
                <span>
                    {tags.map(tag => <Tag color="blue" key={tag}>{tag}</Tag>)}
                </span>
            ),
        },
        { //the column title of the table
            title: 'Open input', //the title of column
            dataIndex: 'questionOpen', //the data index can be used for searching, filtering
            key: 'questionOpen',
            width: '15%',
            render: open => (
                <span>
                    {open ? "YES" : "NO"}
                </span>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            width: '15%',
            render: (text, record) => (
                <span>
                    {/* save the edited alternative data, which will be used later in edit modal, and then show the edit modal */}
                    <Link to="#" onClick={() => { this.setState({ eQuestion: record }); this.showEditModal(); }}>Edit</Link>
                    <Divider type="vertical" />
                    {/* after comfirmation we can delete the alternative */}
                    <Popconfirm title="Are you sure you want to delete this question?" onConfirm={() => { this.deleteMCACriteria(record) }} okText="Yes" cancelText="No">
                        <Link to="#">Delete</Link>
                    </Popconfirm>

                </span>
            ),
        }];

        return <div className="MAMCASurveySetting">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                    <Col span={8}>
                        <h2>MAMCA <sup>&copy; </sup> survey setting: {this.state.projectName}</h2>
                    </Col>
                </Row>
                <Divider />
                <div className="steps-content"></div>
                <Tabs
                    size={"large"}
                    onChange={this.onChange}
                    activeKey={this.state.activeKey}
                >
                    {this.state.panes.map(pane => <TabPane tab={<span><Icon type="team" />{pane.title}</span>} key={pane.key}></TabPane>)}
                </Tabs>
                <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showCreateModal}><b>{"\uFF0B\n"}</b> Create a new survey question</Button>
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    <Table columns={columns}
                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                        dataSource={this.state.MCAQuestions} //the data source is what we get after component mount
                    />
                </ConfigProvider>
                <Divider />
                <div className="steps-action">
                    {/* disabled={this.checkDisable()} */}
                    <Button size="large" type="primary" >
                        <Link to="#" onClick={this.showPublishModal}>Publish survey for this actor group</Link>
                        </Button>
                        <Button size="large" type="primary" style={{ marginLeft: 8 }}>
                        <Link to={`/mamcasurveyresult/${this.props.match.params.projectid}/${this.state.MCAid}`}>Check survey result</Link>
                        </Button>
                        <Button size="large" type="primary" style={{ marginLeft: 8 }}>
                        <Link to={`/mamcasurveyreceived/${this.props.match.params.projectid}/${this.state.MCAid}`}>Received</Link>
                        </Button>
                        <Button size="large" style={{ marginLeft: 8 }}>
                        <Link to={`/`}>Homepage</Link>
                        </Button>
                </div>
            </Spin>
            <CreateForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.createVisible}
                onCancel={this.handleCreateCancel}
                onCreate={this.handleCreate}
                criteriaGroup={this.state.MCACriteriaGroup} //send criteria group
            />
            <EditForm
                wrappedComponentRef={this.saveEFormRef}
                visible={this.state.editVisible}
                onCancel={this.handleEditCancel}
                onCreate={this.handleEdit}
                eQuestion={this.state.eQuestion} //send the edited question info to the modal
            />
            <PublishForm
                wrappedComponentRef={this.savePFormRef}
                visible={this.state.publishVisible}
                onCancel={this.handlePublishCancel}
                onCreate={this.handlePublish}
                actorWeightable={this.state.actorWeightable}
                actorEvaluatable={this.state.actorEvaluatable}
                surveyLink={this.state.surveyLink}
            />
        </div>;
    }
}